import React from 'react';

import { AuditScore } from 'utils/api/modules/entities/entities.types';

import AuditScoreChip from '../AuditScoreChip';
import { Points, SummaryContainer } from './styles';

export type AuditScoreSummaryProps = {
  score: AuditScore | null | undefined;
  /** The header and the Details row both mount one, so the id is caller-owned. */
  'data-testid'?: string;
};

const AuditScoreSummary = ({
  score,
  'data-testid': testId = 'audit-score-summary',
}: AuditScoreSummaryProps): React.ReactElement | null => {
  if (!score || score.percentage === null) {
    return null;
  }

  return (
    <SummaryContainer aria-live="polite" data-testid={testId}>
      <AuditScoreChip percentage={score.percentage} variant="filled" data-testid={`${testId}-chip`} />
      {score.max !== null && (
        <Points>
          {score.earned ?? 0} / {score.max} points
        </Points>
      )}
    </SummaryContainer>
  );
};

export default AuditScoreSummary;
